export default "__VITE_ASSET__BFUWDmT5__"